import * as React from 'react';

import { EnrolledChildDetails } from './EnrolledChildDetails';

import SelectionControlGroup from 'react-md/lib/SelectionControls/SelectionControlGroup';
import { EnrolledChild } from '../Calculation/types';
import { QuestionLabel } from './QuestionLabel';
import { ChildEnrollmentDetails } from './SubsidyCalculationFormContainer';

import './ChildrenEnrolledInDaycare.scss';

interface State {
}

interface Props {
    enrolledChildrenCount: number;
    enrolledChildren: ChildEnrollmentDetails[];
    maximumEnrolledChildren: number;

    onEnrolledChildrenCountUpdated: (value: number) => void;
    onEnrolledChildDetailsUpdated: (index: number, newDetails: EnrolledChild) => void;    
}

export class ChildrenEnrolledInDaycare extends React.Component<Props & React.HTMLAttributes<HTMLDivElement>, State> {
    public render() {
      const { enrolledChildrenCount, enrolledChildren } = this.props;
      
      const childrenCountOptions = Array.from(new Array(this.props.maximumEnrolledChildren), (_, index) => {
        const childNumber = `${index+1}`;
        return {
          label: childNumber,
          value: childNumber
        };
      });
  
      const enrolledChildrenSections = Array.from(new Array(enrolledChildrenCount), (_, index) => {
        const childDetails = enrolledChildren[index];
        return (
          <div key={index} className="enrolled-child-controls">
            <h4>Child {index+1}</h4>
            <EnrolledChildDetails id={index.toString()} enrolledChild={childDetails} onDetailsUpdated={this.props.onEnrolledChildDetailsUpdated.bind(this, index)}></EnrolledChildDetails>
          </div>
        );
      });
  
      return <div className={this.props.className}>
      <QuestionLabel labelText="How many children will you have in long day care?">
        <SelectionControlGroup
              id="enrolledChildrenCount"
              name="enrolledChildrenCount"
              type="radio"
              value={`${enrolledChildrenCount}`}
              onChange={this.setEnrolledChildrenCount}
              inline={true}
              controls={childrenCountOptions}
            />
        </QuestionLabel>
        {enrolledChildrenSections}      
      </div>
    }
  
    private setEnrolledChildrenCount = (value: string) => {
      const enrolledChildrenCount = parseInt(value, 10);
      this.props.onEnrolledChildrenCountUpdated(enrolledChildrenCount)
    };  
  }